import axios from 'axios'

export const getFleetCategory = () => {
  return axios.get('tms/fleet-category')
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getFleetType = (fleetCategory) => {
  return axios.get(`tms/fleet/${fleetCategory}`)
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getOriginCustomer = () => {
  return axios.get('tms/origin')
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}

export const getDestinationCustomer = () => {
  return axios.get('tms/destination')
    .then(res => {
      return res
    })
    .catch(err => {
      throw err.response
    })
}



// WEBPACK FOOTER //
// ./src/api/tms.api.js